import React from "react";
import { useWindupString } from "windups";
export default function TypewriterText(_ref) {
  var children = _ref.children;

  var _useWindupString = useWindupString(children),
      text = _useWindupString[0];

  return React.createElement("p", null, text);
}